import { ProductTransformer } from "./products";

export const CartItemTransformer = (data) => {
  return {
    id: data?.id,
    product: {
      quantity: data?.quantity || 0,
      ...ProductTransformer(data?.variant?.product),
    },
  };
};
